import { useSearchParams } from 'react-router-dom';

export function useQueryFilter<T extends string>(
  key: string,
  fallback = '' as T,
): [T, (value: T) => void] {
  const [params, setParams] = useSearchParams();
  return [
    (params.get(key) ?? fallback) as T,
    (value: T) =>
      setParams(
        (current) => {
          const next = new URLSearchParams(current);
          if (value) next.set(key, value);
          else next.delete(key);
          return next;
        },
        { replace: true },
      ),
  ];
}
